<template>
  <div :class="$options.name">
    <v-card :loading="isLoading" width="800px">
      <user-form
        v-model="form"
        :roles-list="managedRoles"
        :layers-list="layersList"
        :permissions-list="permissionsList"
        :layer-collection-list="collectionList"
        @submit="onCreate"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { GIS_OBZOR_CATEGORY_ID } from '@/utils/consts';
import UserForm from './components/UserForm.vue';

export default {
  name: 'users-create-view',

  asyncData({ store }) {
    const actions = [
      store.dispatch('layerCollections/getFullList'),
    ];

    if (store.state.auth.permissions.includes('userChooseRole')) {
      actions.push(store.dispatch('roles/getFullList'));
    }

    if (
      store.state.auth.permissions.includes('userEditAdditionalPermissions')
      || store.state.auth.permissions.includes('userEditExcludedPermissions')
    ) {
      actions.push(store.dispatch('permissions/getFullList'));
    }

    if (store.state.auth.permissions.includes('userEditLayers')) {
      actions.push(store.dispatch('layer-objects/getFullList', { excludeCategory: [GIS_OBZOR_CATEGORY_ID] }));
    }

    return Promise.all(actions);
  },

  components: { UserForm },

  data: () => ({
    form: null,
    isLoading: false,
  }),

  computed: {
    ...mapState('roles', {
      rolesList: 'fullList',
    }),

    ...mapState('permissions', {
      permissionsList: 'fullList',
    }),

    ...mapState('layer-objects', {
      layersList: 'fullList',
    }),

    ...mapState('layerCollections', {
      collectionList: 'fullList',
    }),

    ...mapState('system', ['isRegionFullListLoaded']),

    profile() {
      return this.$store.getters.profile;
    },

    managedRoles() {
      return this.profile.isAdmin ? this.rolesList : this.profile.managedRoles;
    },
  },

  methods: {
    ...mapActions('users', ['create']),
    ...mapActions(['showNotify']),

    async onCreate() {
      try {
        this.isLoading = true;
        const newUser = await this.create(this.form);
        this.showNotify({ message: 'Пользователь успешно создан' });

        this.isLoading = false;

        this.$router.push({ name: 'users-item', params: { id: newUser.id } });
      } catch (e) {
        this.showNotify({ type: 'error', message: e.message });
      }

      this.isLoading = false;
    },
  },
};
</script>
